<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">ACTUALIZAR TIEMPO LOGIN</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <div class="grey--text text--darken-3 px-4 pt-4">
            <v-radio-group v-model="tipoUser" row>
              <v-radio label="Usuario" :value="email"></v-radio>
              <v-radio
                :label="`Todo los ` + cargoUser"
                :value="cargoUser"
              ></v-radio>
            </v-radio-group>
            <hr />
            <v-radio-group>
              <vue-timepicker
                v-model="time"
                input-class="my-awesome-picker"
              ></vue-timepicker>
            </v-radio-group>
          </div>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="updateTime" color="primary" dark>Guardar </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import { mapState } from "vuex";
import { db } from "../../firebase";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  name: "ModAddTiempoLogin",
  data: () => ({
    loading: false,
    dialog: true,
    tiempoLogin: "",
    datosUsuario: {},
    tipoUser: "user",
    cargoUser: "",
    email: "",
    campo: "",
    time: "",
  }),

  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  components: { VueTimepicker },
  async mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      this.datosUsuario = await db.collection("usuarios").doc(this.id).get();
      const { cargo, email } = this.datosUsuario.data();
      this.cargoUser = cargo;
      this.email = email;
      this.loading = false;
    },
    async updateTime() {
      const hora = this.time.split(":");
      console.log(hora);
      this.tiempoLogin = parseInt(hora[0]) * 60 + parseInt(hora[1]);
      this.campo = this.tipoUser === this.cargoUser ? "cargo" : "email";
      const swal = await this.$swal({
        title: "Actualizar tiempo login",
        text: `¿Esta seguro de actualizar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Actualizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });
      if (swal.isConfirmed) {
        try {
          if (this.tipoUser === "user")
            throw new Error("El tipo de usuario es obligatorio");
          if (!this.tiempoLogin) throw new Error("El tiempo es obligatorio");
          db.collection("usuarios")
            .where(this.campo, "in", [this.tipoUser])
            .get()
            .then((resul) => {
              resul.docs.map((doc) =>
                db
                  .collection("usuarios")
                  .doc(doc.id)
                  .update({ duracion_sesion: this.tiempoLogin })
              );
            });
          this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        } catch (error) {
          this.handleError(error);
        }
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
